(() => {
  if (window.bpsDeliveryInfoInstalled) return;
  window.bpsDeliveryInfoInstalled = true;
  // Capture before the theme's pickup handler, which requests geolocation to calculate distances.
  document.addEventListener('click', event => {
    const opener = event.target.closest('[data-surface-pick-up-embed-modal-btn]');
    if (opener) {
      const dialog = opener.closest('.surface-pick-up-embed')?.querySelector('[data-bps-pickup-dialog]');
      if (!dialog) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      dialog.showModal();
      return;
    }
    const closer = event.target.closest('[data-bps-pickup-close]');
    if (closer) closer.closest('dialog').close();
  }, true);
})();
